import React from "react";
import { productsData } from "../data/productsData";
import ProductCard from "../components/ProductCard";

const Products = () => {
  return (
    <div className="page active">
      <h2 className="page-title">Our Products</h2>
      <div className="product-grid">
        {productsData.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default Products;
